import BaseModel from "../BaseModel";

export default class SampleType extends BaseModel {
    static entity = 'sampleTypes';
    static primaryKey = "uuid";

    static fields() {
        return {
            uuid: this.attr(null),
            name: this.attr(null),
            description: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        }
    }
    static ignoredLogFields(){
        return ['created_at', 'updated_at']
    }
    static name(){
        return "SampleType"
    }

    static route(){
        return process.env.VUE_APP_RECORDED_API + '/sampleTypes';
    }
    static apiConfig = {
        ...super.apiConfig,
        headers: {
            "Accept": "application/json",
            "Authorization": process.env.VUE_APP_RECORDED_API_KEY,
            "VueRoute": window.location.href,
        }
    }
}
